import React from "react";
import AccountSettings from "../../components/AccountSettings";

export default function AdminAccount() {
  return (
    <div data-testid="admin-account-page">
      <h1 className="font-display text-4xl font-semibold text-primary mb-1">My Account</h1>
      <p className="text-muted-foreground mb-8">Update your profile details, photo and password.</p>
      <AccountSettings />
    </div>
  );
}
